import angular from 'angular';
import APIV5 from '~/models/api';

/* globals Knitiv */

export default class MenuDatabaseController {
	/* @ngInject */
	/**
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').route.IRouteService} $route
	 * @param {import('~/scripts/services/model/reset').ResetModel} Reset
	 * @param {Knitiv.UserModel} User
	 */
	constructor(
		$location,
		$rootScope,
		$route,
		Reset,
		User,
	) {
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$route = $route;
		this.Reset = Reset;
		this.User = User;

		/**
		 * @type {Database[]}
		 */
		this.databases = [];

		this.shouldShow = false;

		this.isLoaded = false;

		$rootScope.$on('User.login', () => {
			this.loadDatabases();
		});

		if ($rootScope.context?.token) {
			this.loadDatabases();
		}
	}

	dbName() {
		return this.$rootScope.context?.db?.name ?? '---';
	}

	async loadDatabases() {
		// reset list
		this.databases.length = 0;

		const workspaces = await APIV5.instance.workspaceList({
			tokenid: this.$rootScope.context?.token.id ?? '',
		}, {
			id: 'menu-database.load-databases',
		});

		for (const [environmentKID, environment] of Object.entries(workspaces.workspaces.env_list)) {
			if (environment) {
				for (const database of environment.database_list) {
					this.databases.push({
						env:     environmentKID,
						name:    database.name,
						kid:     database.kid,
						dsnasso: database.dsnasso_kid,
					});
				}
			}
		}

		if (this.databases.length > 1) {
			this.shouldShow = true;
		}
		this.isLoaded = true;
	}

	/**
	 *
	 * @param {Database} database
	 */
	async switchTo(database) {
		if (this.$rootScope.context?.db.kid === database.kid) {
			return;
		}

		const response = await APIV5.instance.tokenChange({ dsnasso: database.dsnasso }, { id: 'menu-database.switch-to'});

		this.Reset.resetApp(true);
		this.User.set(response).saveToken();
		this.$location.url('/').replace();
		this.$route.reload();
	}
}

/**
 * @typedef {Object} Database
 * @property {string} env
 * @property {string} name
 * @property {import('@knitiv/api-client-javascript').KNode} kid
 * @property {import('@knitiv/api-client-javascript').KNode} dsnasso
 */

// eslint-disable-next-line angular/function-type,angular/controller-name
angular.module('app')
	.controller('MenuDatabaseCtrl', MenuDatabaseController);
